import { useAccount } from "wagmi";

export const useTransactionUrl = (hash?: string): string => {
  const { chain } = useAccount();

  if (!chain || !hash) return "";
  const prefix = {
    4: "rinkeby.",
    1: ""
  }[chain?.id];

  return `https://${prefix}etherscan.io/tx/${hash}`;
};
